// Featured products slider
document.addEventListener("DOMContentLoaded", function () {
  $(".jewelry-featured-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// Key categories slider
document.addEventListener("DOMContentLoaded", function () {
  $(".jewelry-categories-grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    infinite: true,
    draggable: true, // Enable dragging with mouse
    swipe: true, // Enable swiping on touch devices
    touchThreshold: 10, // Optional: adjust swipe sensitivity
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// Featured categories slider
document.addEventListener("DOMContentLoaded", function () {
  $(".featured-categories-grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// Featured brand logos slider
document.addEventListener("DOMContentLoaded", function () {
  $(".logo-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// Testimonials slider
document.addEventListener("DOMContentLoaded", function () {
  $(".testimonials-wrapper").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
});

// pdp mobile images slider
document.addEventListener("DOMContentLoaded", function () {
  $(".up-mobile-carousel").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    adaptiveHeight: false,
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Cache DOM elements
  const thumbnails = document.querySelectorAll(".thumbnail-item");
  const mainImages = document.querySelectorAll(".product-image-item");
  const mainImagesContainer = document.querySelector(
    ".product-main-images-wrapper"
  );
  const header =
    document.querySelector("header") || document.querySelector(".site-header"); // Adjust selector based on your theme

  if (!thumbnails.length || !mainImages.length || !mainImagesContainer) return;

  // Set up Intersection Observer to detect which image is in view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const currentIndex = parseInt(entry.target.id.split("-").pop());
          updateActiveThumbnail(currentIndex);
        }
      });
    },
    {
      root: null,
      rootMargin: "-20% 0px -20% 0px",
      threshold: 0.2,
    }
  );

  // Observe all main images
  mainImages.forEach((image) => {
    observer.observe(image);
  });

  // Update active thumbnail
  function updateActiveThumbnail(index) {
    thumbnails.forEach((thumb, i) => {
      if (i === index) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });
  }

  // Calculate header height once
  const headerHeight = header ? header.offsetHeight : 0;
  // Scroll to image when thumbnail clicked
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", function () {
      const targetIndex = parseInt(this.getAttribute("data-index"));
      const targetElement = document.getElementById(
        `product-image-${targetIndex}`
      );

      if (targetElement) {
        // Get exact position considering header height
        const targetPosition =
          targetElement.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });

        // Update active state immediately for better UX
        updateActiveThumbnail(targetIndex);
      }
    });
  });

  // Adjust container position to align with header
  function adjustContainerPosition() {
    if (mainImagesContainer) {
      mainImagesContainer.style.marginTop = "0";
      mainImagesContainer.style.paddingTop = "0";

      // Remove any extra padding or margin from first image
      if (mainImages[0]) {
        mainImages[0].style.marginTop = "0";
        mainImages[0].style.paddingTop = "0";
      }
    }
  }
  // Adjust on load
  adjustContainerPosition();
  // Also adjust on resize
  window.addEventListener("resize", adjustContainerPosition);
});

/* pdp popups */
document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".custom-popup-trigger");
  const overlays = document.querySelectorAll(".custom-popup-overlay");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup");
      const popup = document.querySelector(popupId);
      popup.style.display = "flex";
      popup.setAttribute("aria-hidden", "false");
    });
  });
  overlays.forEach((overlay) => {
    const closeBtn = overlay.querySelector(".custom-popup-close");

    // Close on X click
    closeBtn.addEventListener("click", () => {
      overlay.style.display = "none";
      overlay.setAttribute("aria-hidden", "true");
    });

    // Close when clicking outside content
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.style.display = "none";
        overlay.setAttribute("aria-hidden", "true");
      }
    });
  });
});


/***********************js for mega-menu-hover--start***********************/
// Mega Menu Hover Functionality for Multiple Menus
document.addEventListener('DOMContentLoaded', function() {
    const megaMenus = document.querySelectorAll('.mega-menu');
    let hideTimeout;
    let activeMenu = null;

    // Function to close all menus
    function closeAllMenus() {
        megaMenus.forEach(menu => {
            menu.removeAttribute('open');
            const summary = menu.querySelector('summary');
            summary.setAttribute('aria-expanded', 'false');
        });
        activeMenu = null;
    }

    // Function to open a specific menu
    function openMenu(targetMenu) {
        // Clear any pending hide timeout
        if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
        }

        // Close all other menus first
        megaMenus.forEach(menu => {
            if (menu !== targetMenu) {
                menu.removeAttribute('open');
                const summary = menu.querySelector('summary');
                summary.setAttribute('aria-expanded', 'false');
            }
        });

        // Open the target menu
        targetMenu.setAttribute('open', '');
        const summary = targetMenu.querySelector('summary');
        summary.setAttribute('aria-expanded', 'true');
        activeMenu = targetMenu;
    }

    // Function to hide menu with delay
    function hideMenu() {
        hideTimeout = setTimeout(() => {
            closeAllMenus();
        }, 200);
    }

    megaMenus.forEach(menu => {
        const summary = menu.querySelector('summary');
        const content = menu.querySelector('.mega-menu__content');

        // Show menu on hover
        function showThisMenu() {
            openMenu(menu);
        }

        // Mouse enter events - show this specific menu
        menu.addEventListener('mouseenter', showThisMenu);
        
        // Mouse leave events - hide menu when leaving this menu
        menu.addEventListener('mouseleave', function() {
            // Only hide if this is the active menu
            if (activeMenu === menu) {
                hideMenu();
            }
        });

        // Additional safety: keep menu open when hovering over content
        content.addEventListener('mouseenter', function(e) {
            e.stopPropagation();
            showThisMenu();
        });

        // Prevent default click behavior on summary
        summary.addEventListener('click', function(e) {
            e.preventDefault();
        });

        // Handle keyboard navigation (maintain accessibility)
        summary.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (menu.hasAttribute('open')) {
                    closeAllMenus();
                } else {
                    openMenu(menu);
                }
            }
            
            if (e.key === 'Escape') {
                closeAllMenus();
                summary.focus();
            }

            // Arrow key navigation between menu items
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                const currentIndex = Array.from(megaMenus).indexOf(menu);
                const nextMenu = megaMenus[currentIndex + 1] || megaMenus[0];
                const nextSummary = nextMenu.querySelector('summary');
                closeAllMenus();
                nextSummary.focus();
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                const currentIndex = Array.from(megaMenus).indexOf(menu);
                const prevMenu = megaMenus[currentIndex - 1] || megaMenus[megaMenus.length - 1];
                const prevSummary = prevMenu.querySelector('summary');
                closeAllMenus();
                prevSummary.focus();
            }
        });

        // Handle focus management for accessibility
        const menuLinks = menu.querySelectorAll('.mega-menu__link');
        menuLinks.forEach((link, index) => {
            link.addEventListener('keydown', function(e) {
                if (e.key === 'Tab' && e.shiftKey && index === 0) {
                    // If shift+tab on first link, close menu and focus summary
                    closeAllMenus();
                }
                
                if (e.key === 'Escape') {
                    closeAllMenus();
                    summary.focus();
                }
            });
        });
    });

    // Close all menus when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.mega-menu')) {
            closeAllMenus();
        }
    });

    // Close menus on scroll
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        // Debounce scroll event
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(() => {
            closeAllMenus();
        }, 100);
    });

    // Close menus on window resize
    window.addEventListener('resize', function() {
        closeAllMenus();
    });
});
/***********************js for mega-menu-hover--end***********************/